/*
 * Closes the header store-location popup when its close (X) button is clicked.
 * The popup itself is a Dawn <details-disclosure>, so clicking the map icon again
 * or clicking outside also closes it; this just adds an explicit dismiss control.
 * Delegated on document so it keeps working after theme-editor re-renders.
 */
document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('.header__location-close');
  if (!closeButton) return;

  const details = closeButton.closest('details');
  if (!details) return;

  details.open = false;
  // Return focus to the trigger so keyboard users aren't dropped to the top.
  const summary = details.querySelector('summary');
  if (summary) summary.focus();
});

/*
 * Re-run the popup reveal on every open. A native <details> won't reliably restart
 * the CSS animation on re-open, so toggle + restart an .is-opening class on the
 * details (the CSS keys the reveal on it).
 */
document.querySelectorAll('.header__location > details').forEach((details) => {
  details.addEventListener('toggle', () => {
    if (details.open) {
      details.classList.remove('is-opening');
      void details.offsetWidth; // force reflow so the animation restarts
      details.classList.add('is-opening');
    } else {
      details.classList.remove('is-opening');
    }
  });
});
